import { useState } from "react"
import { TailSpin } from "react-loader-spinner"
import { Link } from "react-router-dom";
import {RecaptchaVerifier,getAuth,signInWithPhoneNumber} from 'firebase/auth'
import app from '../firebase/firebase'
import swal from 'sweetalert';
import {usersRef} from '../firebase/firebase';
import { addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import bcrypt from 'bcryptjs'


const auth = getAuth(app);

const Signup = () => {

    const navigate = useNavigate();

    const [form , setForm] = useState({
        name:"",
        mobile:"",
        password:""
    })

    const [loading, setLoading] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [OTP, setOTP] = useState("");

    const generateRecaptcha = () => {
window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
  'size': 'invisible',
  'callback': (response) => {

  }
}, auth);
}
    const requestOtp = () => {
        setLoading(true);
        generateRecaptcha();
        let appVerifier = window.recaptchaVerifier;
        signInWithPhoneNumber(auth,`+91${form.mobile}`,appVerifier).then(confirmationResult => {
            window.confirmationResult = confirmationResult;
            swal({
                title:"OTP Sent",
                icon: "success",
                button:false,
                timer:3000
            })
            setOtpSent(true);
            setLoading(false)
        }).catch((error)=>{
            console.log(error)
        })
    }

   const verifyOTP = async () => {
    try{
        setLoading(true);
        window.confirmationResult.confirm(OTP).then((Result) => {

            uploadData();

            swal({
                title:"Successfully Registered",
                icon: "success",
                button:false,
                timer:3000
            })
        navigate('/login');
         setLoading(false);
        })
     } catch(error){
        swal({
            title: error,
            icon: "error",
            button:false,
            timer:3000
        })
    }
   
}

    const uploadData = async () => {
        try{
        const salt = bcrypt.genSaltSync(10);
        var hash  = bcrypt.hashSync(form.password,salt);

        await addDoc(usersRef, {
            name: form.name,
            password: hash,
            mobile: form.mobile
        })
    }catch(err){
        swal({
            title: err,
            icon: "error",
            button:false,
            timer:3000
        })
    }
}

    return (
        <div className="w-full flex flex-col items-center mt-8">
            <h1 className=" text-xl font-bold">SignUp</h1>
            {otpSent ? 
            <>
            <div class="p-2 w-full md:w-1/3">
                <div class="relative">
                    <label for="name" class="leading-7 text-sm text-white">OTP</label>
                    <input
                        
                        id="name"
                        name="name"
                        value={OTP}
                        onChange={(e)=> setOTP(e.target.value)}
                        class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                </div>
             </div>
             <div class="p-2 w-full">
                <button onClick={verifyOTP} class="flex mx-auto text-white bg-green-600 border-0 py-2 px-8 focus:outline-none hover:bg-green-700 rounded text-lg">
                    {loading ? <TailSpin height={25} color="white" /> : "Confirm OTP"}
                </button>
            </div>
            </>
            :
                <>
            
            <div class="p-2 w-full md:w-1/3">
                <div class="relative">
                    <label for="name" class="leading-7 text-sm text-white">Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={form.name}
                        onChange={(e)=> setForm({...form,name:e.target.value})}
                        class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                </div>
            </div>
            <div class="p-2 w-full md:w-1/3">
                <div class="relative">
                    <label for="name" class="leading-7 text-sm text-white">Mobile Number</label>
                    <input
                        type={"number"}
                        id="name"
                        name="name"
                        value={form.mobile}
                        onChange={(e)=> setForm({...form,mobile:e.target.value})}
                        class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                </div>
                
            </div>
            <div class="p-2 w-full md:w-1/3">
                <div class="relative">
                    <label for="email" class="leading-7 text-sm text-white">Password</label>
                    <input
                        type={'password'}
                        id="text"
                        name="text"
                        value={form.password}
                        onChange={(e)=> setForm({...form,password:e.target.value})}

                        class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                </div>
            </div>
            <div class="p-2 w-full">
                <button onClick={requestOtp} class="flex mx-auto text-white bg-green-600 border-0 py-2 px-8 focus:outline-none hover:bg-green-700 rounded text-lg">
                    {loading ? <TailSpin height={25} color="white" /> : "Request OTP"}
                </button>
            </div>
            </>
            }
            <div>
                <p>Already have an account<Link to={'/login'}><span className="text-blue-500">Login</span></Link></p>
            </div>
            <div id="recaptcha-container"></div>
        </div>
    )
}

export default Signup